import * as Haptics from 'expo-haptics';
import { Platform } from 'react-native';

export const withHapticFeedback = (callback?: () => void) => (): void => {
  if (!callback) {
    return;
  }
  if (Platform.OS === 'ios') {
    Haptics.selectionAsync();
  }
  callback();
};

export const hapticSelection = () =>
  Platform.OS === 'ios' && Haptics.selectionAsync();
